import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 8.74 14.66' {...props}>
    <g data-name='Layer 2'>
      <path
        fill='undefined'
        d='M8.74 7.33l-7.33 7.33L0 13.24l5.91-5.91L0 1.41 1.41 0l7.33 7.33z'
        data-name='general content'
      />
    </g>
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/CaretIcon.js